/* eslint-disable */
export default function init(Blockly, profile, img_path) {
    Blockly.Blocks.time = {};
    Blockly.Blocks.time.style = 'time_blocks';
    Blockly.Blocks.time_delay = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.time.style);
            this.appendValueInput("DELAY_TIME_MILI").setCheck("Number").appendField(Blockly.Msg.TIME_WAIT);
            this.appendDummyInput().appendField(Blockly.Msg.TIME_MILLIS);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.time_delay_seconds = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.time.style);
            this.appendValueInput("DELAY_TIME_SECONDS").setCheck("Number").appendField(Blockly.Msg.TIME_WAIT);
            this.appendDummyInput().appendField(Blockly.Msg.TIME_SECONDS);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.time_delaymicros = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.time.style);
            this.appendValueInput("DELAY_TIME_MICRO").setCheck("Number").appendField(Blockly.Msg.TIME_WAIT);
            this.appendDummyInput().appendField(Blockly.Msg.TIME_MICROS);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.time_millis = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.time.style);
            this.appendDummyInput("").appendField(Blockly.Msg.TIME_TIME_ELAPSED_MILLI);
            this.setOutput(!0, "Number")
        }
    };
    Blockly.Blocks.time_seconds = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.time.style);
            this.appendDummyInput("").appendField(Blockly.Msg.TIME_TIME_ELAPSED_SECONDS);
            this.setOutput(!0, "Number")
        }
    };
    Blockly.Blocks.time_micros = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.time.style);
            this.appendDummyInput("").appendField(Blockly.Msg.TIME_TIME_ELAPSED_MICRO);
            this.setOutput(!0, "Number")
        }
    };
    Blockly.Blocks.time_runeveryms = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.time.style);
            this.setPreviousStatement(!0);
            this.setNextStatement(!0);
            this.appendDummyInput().appendField(Blockly.Msg.TIME_RUNEVERYMS);
            this.appendValueInput("MS", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT);
            this.appendDummyInput().appendField("ms");
            this.appendStatementInput("DO").appendField("");
            this.setInputsInline(!0)
        }
    };
    Blockly.Blocks.time_runeverys = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.time.style);
            this.setPreviousStatement(!0);
            this.setNextStatement(!0);
            this.appendDummyInput().appendField(Blockly.Msg.TIME_RUNEVERYMS);
            this.appendValueInput("S", "Number").setCheck("Number").setAlign(Blockly.ALIGN_RIGHT);
            this.appendDummyInput().appendField("s");
            this.appendStatementInput("DO").appendField("");
            this.setInputsInline(!0)
        }
    };
    Blockly.Blocks.infinite_loop = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.time.style);
            this.appendDummyInput().appendField(Blockly.Msg.TIME_WAIT_FOREVER);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0)
        }
    };
    Blockly.Blocks.time_timer = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.time.style);
            this.appendDummyInput("").appendField(Blockly.Msg.TIME_TIMER).appendField(new Blockly.FieldDropdown([
                ["ms", "ms"],
                ["s", "s"]
            ]), "TYPE");
            this.setInputsInline(!0);
            this.setOutput(!0, "Number")
        }
    };
    Blockly.Blocks.time_timer_lite = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.time.style);
            this.appendDummyInput("").appendField(Blockly.Msg.TIME_TIMER).appendField(new Blockly.Field("s"), "TYPE");
            this.setInputsInline(!0);
            this.setOutput(!0, "Number")
        }
    };
    Blockly.Blocks.time_timer_reset = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.time.style);
            this.appendDummyInput("").appendField(Blockly.Msg.TIME_TIMER_RESET);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
}
